/** @prettier */
import {useEffect, useRef} from 'react';
/* タイマ動作後にUnitOtherIDが変わった場合、1分後に参照するsiteIDはタイマ動作開始時のUnitOtherIDとなるため */
/* useRefを使って、現在のUnitOtherIDを参照するようにしている。 */
/**
 * タイマによる更新対象の変更
 * @param val UnitOtherID
 */
export function useValueRef<T>(val: T) {
  const ref = useRef(val);

  useEffect(() => {
    ref.current = val;
  }, [val]);

  return ref;
}
